/**
 * orga-app-api - vorlagen-v1-oa3_1
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface DokumentBerechtigung { 
    dokument_id: string;
    benutzer_kann_bearbeiten?: boolean;
    mandant_id: string;
    benutzer_id: string;
}

